// LeadTypeAddAndEditModal
import React, { useEffect, useState } from 'react'
import RouteModal from '../../../../Component/BasicComponents/Modal/RouteModal';
import CustomInput from '../../../../Component/BasicComponents/CustomInput';
import ReusableDropdown from '../../../../Component/BasicComponents/Dropdowns/RouteDropdown';
import { Btn } from '../../../../AbstractElements';
import MultiSelectDropdown from '../../../../Component/BasicComponents/Dropdowns/MultiSelectDropdown';
import { useOutletTypesData, useSubscriberTypesData } from '../../Subscriber/hooks/useSubscriber';
import RouteDropdown from '../../../../Component/BasicComponents/Dropdowns/RouteDropdown';
import { toast } from 'react-toastify';
import { useAddLeadTypes, useUpdateLeadType } from '../hooks/useLead';

type ProductCardProps = {
    setIsModalOpen?: any;
    isModalOpen?: any;
    toggleModal?: any;
    title?: any;
    checkAddEditStatus?: any;
    setCheckAddEditStatus?: any;
    rowData?: any;
};
const LeadTypeAddAndEditModal: React.FC<ProductCardProps> = ({ rowData, setIsModalOpen, isModalOpen, title, checkAddEditStatus, setCheckAddEditStatus }) => {
    const { data } = useOutletTypesData({ enable: true });
    const { data: subscriberType } = useSubscriberTypesData({
        enable: true, params: {}
    });
    // console.log('subscriberType',subscriberType?.data)
    const [modalValues, setModalValues] = useState<any>({
        LeadName: '',
        OutletTypes: '',
        SubscriberTypes: [] as { id: number; name: string }[],
    })

    const { mutate } = useAddLeadTypes()
    const { mutate: updateMutate } = useUpdateLeadType()

    const handleSubscriberType = (selectedValues: string[] | number[]) => {
        let selectedData = selectedValues.map((id) =>
            subscriberType?.data?.find((unit: any) => Number(unit.id) === Number(id))
        );
        setModalValues((prevState: any) => ({ ...prevState, SubscriberTypes: selectedData.filter(Boolean) }));
    };

    const handleClose = () => {
        setIsModalOpen(false);
        setCheckAddEditStatus('');
        setModalValues((prevState: any) => ({ ...prevState, LeadName: '', OutletTypes: '', SubscriberTypes: [] }))
    }

    const handleSubmit = (e: React.FormEvent) => {

        e.preventDefault();
        if (!modalValues?.OutletTypes) {
            toast.warn("Please select outlet type.");
            return;
        }
        if (modalValues?.SubscriberTypes?.length <= 0) {
            toast.warn("Please select outlet type.");
            return;
        }
        const body = {
            LeadName: modalValues?.LeadName,
            OutletTypes: Number(modalValues?.OutletTypes),
            SubscriberTypes: modalValues?.SubscriberTypes?.map((itm: any) => Number(itm?.id)),
        };

        if (checkAddEditStatus === "Add") {
            mutate(body, {
                onSuccess: () => {
                    handleClose();
                },
            });
        } else {
            updateMutate(
                { id: Number(rowData?.LeadTypeId), body },
                {
                    onSuccess: () => {
                        handleClose();
                    },
                }
            );
        }
    };

    useEffect(() => {
        if (checkAddEditStatus === 'Edit') {
            console.log('rowwww lead type', rowData)
            let updatedArr = rowData?.SubscriberTypes.map((item:any) => ({
                id:item?.id,
                label: item?.name
            }));
            // let formattedData = subscriberType?.data?.filter((i: any) =>SubscriberTypes?.includes(i?.id));

            setModalValues((prevState: any) => ({ ...prevState, SubscriberTypes: updatedArr, LeadName: rowData?.LeadName,OutletTypes:rowData?.OutletTypeId }))
        }
    }, [checkAddEditStatus])

    return (
        <RouteModal
            isOpen={isModalOpen}
            toggle={() => { setIsModalOpen(!isModalOpen); setModalValues((prevState: any) => ({ ...prevState, LeadName: '', OutletTypes: '', SubscriberTypes: [] })) }}
            title={title}
            size="md"
            content={
                <form onSubmit={handleSubmit}>
                    <div className="row mb-0">
                        <CustomInput
                            placeholder="Lead Name"
                            disabled={false}
                            onChange={(e: any) => { setModalValues((prevState: any) => ({ ...prevState, LeadName: e.target.value })); }}
                            value={modalValues?.LeadName}
                            required={true}
                            label="Lead Name*"
                            style={{
                                border: "1px solid #EDEDED",
                                borderRadius: "4px",
                                padding: "10px",
                                fontSize: "14px",
                                backgroundColor: "#fff",
                            }}
                        />

                        <RouteDropdown
                            options={data?.data || []}
                            value={modalValues?.OutletTypes}
                            onChange={(value: any) => {
                                setModalValues((prevState: any) => ({ ...prevState, OutletTypes: value }));
                            }}
                            DropdownHeading="Outlet Type*"
                        />
                        <RouteDropdown
                            isMulti={true}
                            options={subscriberType?.data || []}
                            value={modalValues.SubscriberTypes.map((val: any) => val.id.toString())}
                            onChange={(value: any) => {
                                handleSubscriberType(value)
                            }}
                            DropdownHeading="Subscriber Type*"
                        />

                        <div style={{ height: 20 }} />
                        <div className="d-flex justify-content-start gap-2">
                            <Btn
                                style={{ backgroundColor: "#43B9B2", color: "white" }}
                                type="submit"
                            >
                                {checkAddEditStatus === 'Add' ? 'Submit' : 'Update'}
                            </Btn>
                            <Btn
                                style={{
                                    backgroundColor: "#F9FAFC",
                                    color: "#000",
                                    border: "1px solid #E0E0E0",
                                }}
                                type="button"
                                onClick={() => { setIsModalOpen(false); setCheckAddEditStatus(''); setModalValues((prevState: any) => ({ ...prevState, LeadName: '', OutletTypes: '', SubscriberTypes: [] })); }}
                            >
                                Cancel
                            </Btn>
                        </div>



                    </div>
                </form>
            }
        />
    )
}

export default LeadTypeAddAndEditModal